// Myprofile.jsx
import React, { useEffect, useState } from 'react';
import { getRequest } from '../../apis/ApiInstence';

const Myrpofile = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
     const id = localStorage.getItem("userId");
      console.log("Fetched ID from localStorage:", id);

      if (!id) return;

      try {
        const res = await getRequest(`customer/one/${id}`);
        console.log("API Response:", res);
        setUser(res?.data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">My Profile</h2>
      {user ? (
        <div>
          <p><strong>Name:</strong> {user.name}</p>
          <p><strong>Mobile:</strong> {user.mobile}</p>
          <p><strong>Address:</strong> {user.address}</p>
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default Myrpofile;
